import Epi, { FinderEpis, RetornoEpi } from 'Interface/Epis';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { paramsParaString } from '../utils';

const tag = 'Epis';

const url = '/epis';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarEpis: construtor.query<FinderEpis, Parametros | void>({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.epis
            ? [
                ...resultado.epis.map(({ id }) => ({ type: tag, id } as const)),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarEpi: construtor.query<RetornoEpi, string | number | Parametros>({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarEpi: construtor.mutation<RetornoEpi, Partial<Epi>>({
        query: (dados) => ({ url: url, method: 'POST', body: dados }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarEpi: construtor.mutation<
        RetornoEpi,
        Partial<Epi> & Pick<Epi, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'PUT',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerEpi: construtor.mutation<
        RetornoEpi,
        Partial<Epi> & Pick<Epi, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'DELETE',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarEpisQuery,
  useRecuperarEpiQuery,
  useAdicionarEpiMutation,
  useEditarEpiMutation,
  useRemoverEpiMutation,
} = apiExtendida;
